import { useEffect, useRef } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import SignaturePad from 'signature_pad';
import type { UseSignatureResult } from './types';

export function useSignature(): UseSignatureResult {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const signatureRef = useRef<SignaturePad | null>(null);
  useEffect(() => {
    if (canvasRef.current == null) {
      return;
    }

    signatureRef.current = new SignaturePad(canvasRef.current, {
      backgroundColor: 'rgb(255,255,255)'
    });

    const canvas = canvasRef.current;
    function resizeCanvas(): void {
      // When zoomed out to less than 100%, for some very strange reason,
      // some browsers report devicePixelRatio as less than 1
      // and only part of the canvas is cleared then.
      const ratio = Math.max(window.devicePixelRatio, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext('2d')?.scale(ratio, ratio);
    }

    resizeCanvas();

    window.addEventListener('resize', resizeCanvas);
    return (): void => window.removeEventListener('resize', resizeCanvas);
  }, []);

  return { canvasRef, signatureRef };
}
